import { Outlet } from "react-router-dom";
import { BrandHeaderNav } from "@/components/BrandHeaderNav";
import { Footer } from "@/components/Footer";
import { MusicPlayer } from "@/components/MusicPlayer";

export const Layout = () => (
  <div className="App grain flex min-h-screen flex-col">
    <BrandHeaderNav />
    <main className="relative z-10 flex-1">
      <Outlet />
    </main>
    <Footer />
    <MusicPlayer />
  </div>
);
